import I18n from 'i18n-js';
import React from 'react';

import PriceDisplay from './price_display';
import ProximityModal from './proximity_modal';
import { core_apimessages_Money as IMoney } from '../rql';

interface IProps {
  postalCode?: string;
  standardShippingPrice?: IMoney;
}

export default function CarrierCalculatedShippingDisplay({ postalCode, standardShippingPrice }: IProps) {
  const editButtonText = postalCode || I18n.t('commons.calculateShipping');
  const [isModalOpen, setOpenModal] = React.useState(false);

  return (
    <div className="listing-shipping-display">
      <ProximityModal
        isModalOpen={isModalOpen}
        setModal={setOpenModal}
        propsPostalCode={postalCode}
      />

      {postalCode && (
        <span className="listing-shipping-display__to-postal">
          {standardShippingPrice && (
            <>
              {'+ '}
              <PriceDisplay
                amountCents={standardShippingPrice.amountCents}
                currency={standardShippingPrice.currency}
                display={standardShippingPrice.display}
              />
              {` ${I18n.t('commons.shippingTo')}`}
            </>
          )}

          {!standardShippingPrice && I18n.t('commons.unavailableTo')}
        </span>
      )}

      <button
        type="button"
        className="button-as-link"
        onClick={(e) => {
          e.preventDefault();
          setOpenModal(true);
        }}
      >
        {editButtonText}
      </button>
    </div>
  );
}
